import { createContext, useContext, type ReactNode } from 'react';

// The signed-in person, lifted out of the Kinde session by App. We read it via a
// Loft-owned context rather than useKindeAuth() directly, because that hook
// throws outside a KindeProvider (e.g. in Storybook) — useContext just returns
// null there, so consumers degrade gracefully instead of crashing.
export type LoftUser = {
  email?: string;
  givenName?: string;
  familyName?: string;
  picture?: string;
} | null;

const LoftUserContext = createContext<LoftUser>(null);

export const LoftUserProvider = ({
  user,
  children,
}: {
  user: LoftUser;
  children: ReactNode;
}) => (
  <LoftUserContext.Provider value={user}>{children}</LoftUserContext.Provider>
);

// The current user, or null outside the app shell (Storybook, tests).
export const useLoftUser = (): LoftUser => useContext(LoftUserContext);
